import { Pipe, PipeTransform } from '@angular/core';
import { contactRoles } from '@shared/constants/contact-roles';

@Pipe({
  name: 'contactRole',
  standalone: true,
})
export class ContactRolePipe implements PipeTransform {
  /**
   * Transforms a contact role reference into its display title
   * @param roleReference The reference code of the contact role
   * @param groupType Optional group type to handle special cases
   * @returns The display title for the role
   */
  transform(roleReference: string, groupType?: string): string {
    // Special case for primary role when not in a customer group
    if (roleReference === 'primary' && groupType && groupType !== 'customer') {
      return 'Administrator';
    }

    const role = contactRoles.find((role) => role.reference === roleReference);
    return role?.title || roleReference;
  }
}
